import { ActionIcon, type ActionIconProps } from '@mantine/core';
import { IconX, IconPlus } from '@tabler/icons-react';
import type { ReactNode } from 'react';

interface IconRoundButtonProps extends Omit<ActionIconProps, 'radius'> {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
  'aria-label': string;
}

/**
 * Иконочная кнопка с круглым фоном при hover.
 * Базовый примитив — используй готовые кнопки DeleteIconButton / AddIconButton,
 * или этот компонент если нужна кастомная иконка.
 */
export function IconRoundButton({ children, variant = 'subtle', ...props }: IconRoundButtonProps) {
  return (
    <ActionIcon radius='xl' variant={variant} {...props}>
      {children}
    </ActionIcon>
  );
}

interface SimpleIconButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  style?: React.CSSProperties;
  className?: string;
}

/**
 * Готовая кнопка удаления — красный крестик в круге.
 * Просто передай onClick.
 */
export function DeleteIconButton({ onClick, style, className }: SimpleIconButtonProps) {
  return (
    <IconRoundButton
      size='sm'
      color='red'
      onClick={onClick}
      aria-label='Удалить'
      style={style}
      className={className}
    >
      <IconX size={14} />
    </IconRoundButton>
  );
}

/**
 * Готовая кнопка добавления — плюс в круге.
 * Просто передай onClick.
 */
export function AddIconButton({
  onClick,
}: {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}) {
  return (
    <IconRoundButton size='sm' onClick={onClick} aria-label='Добавить'>
      <IconPlus size={14} />
    </IconRoundButton>
  );
}
